import $ from 'jquery';

import 'picturefill';

